import { render, staticRenderFns } from "./storehouseManageList.vue?vue&type=template&id=b77c3cfe&scoped=true"
import script from "./storehouseManageList.vue?vue&type=script&lang=js"
export * from "./storehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./storehouseManageList.vue?vue&type=style&index=0&id=b77c3cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c3cfe",
  null
  
)

export default component.exports